import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 500 }, // Default 2 seconds delay
  };

  connect() {
    this.setupAutosave();
  }

  disconnect() {
    // Clear any pending autosave timer
    if (this.autosaveTimer) {
      clearTimeout(this.autosaveTimer);
    }

    // Remove event listeners
    this.element.removeEventListener("input", this.scheduleAutosave);
    this.element.removeEventListener("change", this.scheduleAutosave);
  }

  setupAutosave() {
    const form = this.element;

    if (!(form instanceof HTMLFormElement)) {
      console.error("Autosave can only be applied to form elements");
      return;
    }

    // Add input event listeners to the form
    form.addEventListener("input", this.scheduleAutosave);
    form.addEventListener("change", this.scheduleAutosave);
  }

  scheduleAutosave = () => {
    // Clear previous timer if it exists
    if (this.autosaveTimer) {
      clearTimeout(this.autosaveTimer);
    }

    // Set a new timer
    this.autosaveTimer = setTimeout(() => {
      this.performAutosave();
    }, this.delayValue);
  };

  performAutosave() {
    const form = this.element;
    form.requestSubmit();
    // We can use FormData directly with Turbo's submitForm
    // No need to modify the actual form DOM

    // Use Turbo to submit the form
    // Turbo.navigator.submitForm(form);
  }
}
